import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const home: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M11-4.25V-.5a.5.5 0 0 1-.156.36.47.47 0 0 1-.344.14h-3v-3h-2v3h-3a.52.52 0 0 1-.36-.14A.52.52 0 0 1 2-.5v-3.781l.016-.016L6.5-8 11-4.297zm1.75-.547-.484.578a.25.25 0 0 1-.172.094h-.016q-.112 0-.172-.062L6.5-8.687l-5.406 4.5a.33.33 0 0 1-.188.062.22.22 0 0 1-.156-.094l-.484-.578a.26.26 0 0 1-.063-.172.25.25 0 0 1 .094-.172l5.61-4.687a.92.92 0 0 1 .593-.203q.341.002.594.203L9-8.234V-9.75q0-.106.063-.172A.26.26 0 0 1 9.25-10h1.5q.106 0 .172.078.076.066.078.172v3.188l1.719 1.421q.076.066.078.172a.23.23 0 0 1-.047.172m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(-.203 10.031)"
    />
  ),
  svgProps: {
    height: "10.031",
    width: "12.596",
  }
};
